var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAccepted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.58594 13.3837L6.46094 10.2581L7.34407 9.375L9.58594 11.6163L14.3266 6.875L15.2109 7.75938L9.58594 13.3837Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8359 1.25C9.10535 1.25 7.41363 1.76318 5.9747 2.72464C4.53577 3.6861 3.41426 5.05267 2.752 6.65152C2.08973 8.25037 1.91645 10.0097 2.25407 11.707C2.59169 13.4044 3.42505 14.9635 4.64876 16.1872C5.87247 17.4109 7.43157 18.2442 9.1289 18.5819C10.8262 18.9195 12.5856 18.7462 14.1844 18.0839C15.7833 17.4217 17.1498 16.3002 18.1113 14.8612C19.0728 13.4223 19.5859 11.7306 19.5859 10C19.5859 7.67936 18.6641 5.45376 17.0231 3.81282C15.3822 2.17187 13.1566 1.25 10.8359 1.25ZM10.8359 17.5C9.35258 17.5 7.90253 17.0601 6.66916 16.236C5.4358 15.4119 4.4745 14.2406 3.90684 12.8701C3.33919 11.4997 3.19066 9.99168 3.48005 8.53682C3.76944 7.08197 4.48375 5.74559 5.53264 4.6967C6.58153 3.64781 7.91791 2.9335 9.37276 2.64411C10.8276 2.35472 12.3356 2.50325 13.7061 3.0709C15.0765 3.63856 16.2479 4.59985 17.072 5.83322C17.8961 7.06659 18.3359 8.51664 18.3359 10C18.3359 11.9891 17.5458 13.8968 16.1392 15.3033C14.7327 16.7098 12.8251 17.5 10.8359 17.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAccepted);
export default __webpack_public_path__ + "static/media/ic-accepted.6d55bae925352f8fcb9d642053faa02d.svg";
export { ForwardRef as ReactComponent };